/**
 * The leaf motif (docs/DESIGN.md: "the leaf is THE motif — it may appear in empty states... and
 * nowhere else"). Same single-path drawing as `BrandMark`'s icon, factored out so every empty/
 * all-done state across the app draws the identical mark instead of a slightly-different copy.
 */
export function LeafMark({ className = '', size = 26 }: { className?: string; size?: number }) {
  return (
    <svg viewBox="0 0 32 26" width={size} height={size} aria-hidden="true" className={`shrink-0 ${className}`}>
      <path
        fill="currentColor"
        d="M14.69 2.07 Q19.29 7.76 25.75 8.41 Q21.48 14.98 23.43 21.19 Q16.00 18.30 8.57 21.19 Q10.52 14.98 6.25 8.41 Q12.03 8.14 14.69 2.07 Z
           M15.3 18.0 L16.7 18.0 L17.7 23.5 Q16.3 21.5 15.3 18.0 Z"
      />
    </svg>
  );
}
